import { render } from "./InterpretedDate.vue?vue&type=template&id=4a5e5401"
import script from "./InterpretedDate.vue?vue&type=script&lang=js"
export * from "./InterpretedDate.vue?vue&type=script&lang=js"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__